import { render, staticRenderFns } from "./CampaignMessageCard.vue?vue&type=template&id=4dae2cb9&"
import script from "./CampaignMessageCard.vue?vue&type=script&lang=js&"
export * from "./CampaignMessageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports